import { useRef, useState } from 'react';

import { BasketStatus } from '@generated/gql/graphql';
import { bundleSubmissionValidator } from '@utils/basketStatusValidation';

const useBundleValidation = (basketStatus: BasketStatus) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const errorRef = useRef<HTMLDivElement>(null);

  const validateSelection = () => {
    // reasonOverwrite is generic solution for combined basket status messages
    const { isValid, reason: reasonOverwrite } =
      bundleSubmissionValidator(basketStatus);

    if (isValid) {
      setShowAlert(false);
      return true;
    }

    let reason =
      basketStatus.unavailableStatuses?.[0]?.reasons?.[0]?.description ||
      'Selection is invalid';

    if (reasonOverwrite) {
      reason = reasonOverwrite;
    }

    setAlertMessage(reason);
    setShowAlert(true);
    errorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  };

  return { showAlert, alertMessage, errorRef, validateSelection };
};

export { useBundleValidation };
